import React from "react";
import { useNavigate } from "react-router-dom";
import "./Main.css";

const blocks = [
  {
    key: "kitchen",
    label: "廚房",
    img: process.env.PUBLIC_URL + "/img/kitchen.webp",
    path: "/main/kitchen"
  },
  {
    key: "bathroom",
    label: "浴室",
    img: process.env.PUBLIC_URL + "/img/bathroom.webp",
    path: "/main/bathroom"
  },
  {
    key: "bedroom",
    label: "臥室",
    img: process.env.PUBLIC_URL + "/img/bedroom.webp",
    path: "/main/bedroom"
  },
  {
    key: "items",
    label: "各類用品",
    img: process.env.PUBLIC_URL + "/img/items.webp",
    path: "/main/items"
  },
  {
    key: "garden",
    label: "園藝",
    img: process.env.PUBLIC_URL + "/img/garden.webp",
    path: "/main/garden"
  }
];

export default function Main() {
  const navigate = useNavigate();
  return (
    <div className="main-page-bg">
      <div className="main-header">
        <img src={process.env.PUBLIC_URL + "/img/01.webp"} alt="Lulu" className="lulu-avatar" />
        <div className="main-title-block">
          <div className="main-title">我是防霉大使Lulu～</div>
          <div className="main-subtitle">今天就讓我帶你看看，黴菌家族最喜歡住在哪裡吧！</div>
        </div>
      </div>
      <div className="main-blocks">
        {blocks.map(block => (
          <div
            key={block.key}
            className="main-block"
            onClick={() => navigate(block.path)}
          >
            <img src={block.img} alt={block.label} className="block-img" />
            <div className="block-label">{block.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
